import { colors } from '@noths/polaris-client-ribbons-design-system';
import { pxToRem, stack, theme } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

import {
  STAR_RATING_CONTAINER_CLASS,
  STAR_RATING_REVIEWS_CLASS,
} from 'src/components/molecules/StarRating';

const { spacing } = theme;

export const ratingHeader = css`
  margin: ${stack(20)};
  font-size: ${pxToRem(18)};
`;

export const overallRatingContainer = css`
  display: grid;
  align-items: baseline;
  width: 100%;
  padding: ${pxToRem(spacing.xl)};
  border: ${pxToRem(1)} solid ${colors.neutralLight};
  border-radius: 0.35rem;

  .${STAR_RATING_CONTAINER_CLASS} {
    margin: 0;
  }

  .${STAR_RATING_REVIEWS_CLASS} {
    font-size: ${pxToRem(14)};
    line-height: ${pxToRem(24)};
  }
`;

export const overallRating = css`
  font-size: ${pxToRem(32)};
`;

export const overallRatingLabel = css`
  margin: ${stack(8)};
`;
